"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.borrowerChargeSchema = void 0;
var constants_1 = require("../../constants");
var accrued_interest_calculation_schema_1 = require("./accrued-interest-calculation-schema");
var credit_of_receipt_interest_calculation_schema_1 = require("./credit-of-receipt-interest-calculation-schema");
exports.borrowerChargeSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    anyOf: [
        {
            required: [
                'code',
                'indexNumber',
                'originalClaimSequenceNumber',
                'receivedAmount',
                'receivedDate',
            ],
        },
        {
            required: [
                'code',
                'indexNumber',
                'originalClaimSequenceNumber',
                'previouslyApprovedAmount',
                'previouslyApprovedDate',
            ],
        },
    ],
    properties: {
        acceptableAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        acceptableDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        adjustedAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        adjustedDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        code: {
            type: 'string',
            enum: Object.values(constants_1.BorrowerChargesCode),
            errorMessage: 'should be a valid BorrowerChargesCode Enum value',
        },
        comment: {
            type: 'string',
            minLength: 0,
            maxLength: 40,
            errorMessage: 'should have maximum length of 40 characters',
        },
        indexNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 300,
            errorMessage: 'Should be an integer between 0 and 300',
        },
        originalClaimSequenceNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 32767,
            errorMessage: 'Should be an integer between 0 and 32767',
        },
        previouslyApprovedAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        previouslyApprovedComment: {
            type: 'string',
            minLength: 0,
            maxLength: 40,
            errorMessage: 'should have maximum length of 40 characters',
        },
        previouslyApprovedDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        previouslyReceivedAmount: {
            // TODO: Added for reporting purposes for AIP - maybe remove in R3
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        previouslyReceivedDate: {
            // TODO: Added for reporting purposes for AIP - maybe remove in R3
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        receivedAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        receivedDate: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
        accruedInterestCalculations: {
            type: ['array', 'null'],
            items: accrued_interest_calculation_schema_1.accruedInterestCalculationSchema,
        },
        creditOfReceiptInterestCalculation: credit_of_receipt_interest_calculation_schema_1.creditOfReceiptInterestCalculationSchema,
    },
};
